module.exports = __webpack_public_path__ + "static/img/irole.fdd9c21.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/u/irole.png
// module id = aGPn
// module chunks = 7